<template>
  <div class="page-portail-client">
    <landing-header />

    <main>
      <section class="hero-portail">
        <div class="max-w-7xl mx-auto px-4 flex flex-col lg:flex-row items-center gap-16">
          <div class="lg:w-1/2">
            <span class="badge-portail">Expérience Client Premium</span>
            <h1 class="text-4xl md:text-6xl font-black text-gray-900 mb-6 leading-tight">
              Votre agence ouverte <br />
              <span class="gradient-text">24h/24 et 7j/7</span>
            </h1>
            <p class="text-xl text-gray-600 mb-8 leading-relaxed">
              Offrez à vos clients l'autonomie qu'ils attendent. Un espace sécurisé pour consulter leurs interventions, télécharger leurs CERFA et suivre leurs contrats en un clic.
            </p>
            <div class="flex flex-wrap gap-4">
              <a href="/contact"><button class="btn-primary">Demander une démonstration</button></a>
              <a href="/fonctionnalites" class="btn-outline-large">Autres fonctionnalités</a>
            </div>
          </div>
          
          <div class="lg:w-1/2 w-full">
            <div class="browser-mockup shadow-2xl">
              <div class="browser-bar">
                <div class="dots"><span></span><span></span><span></span></div>
                <div class="url">client.votre-entreprise.fr</div>
              </div>
              <div class="browser-content">
                <div class="sidebar-mock"></div>
                <div class="main-mock">
                  <div class="mock-card-wide">
                    <div class="flex justify-between items-center mb-4">
                      <span class="font-bold">Dernier rapport d'intervention</span>
                      <span class="btn-mock">Télécharger PDF</span>
                    </div>
                    <div class="h-2 bg-gray-100 rounded"></div>
                  </div>
                  <div class="grid grid-cols-2 gap-4">
                    <div class="mock-card-small">Mes Équipements</div>
                    <div class="mock-card-small">Mes Contrats</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="py-24 bg-white">
        <div class="max-w-7xl mx-auto px-4">
          <div class="text-center mb-20">
            <h2 class="text-3xl font-bold text-gray-900 mb-4">La transparence au service de la fidélité</h2>
            <p class="text-gray-600">Réduisez vos appels entrants en donnant un accès direct à l'information.</p>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-3 gap-12">
            <div class="feature-card">
              <i class="fa-solid fa-folder-open text-orange-500 text-3xl mb-6"></i>
              <h3 class="text-xl font-bold mb-4">Documents en libre-service</h3>
              <p class="text-gray-600">Bons d’intervention, CERFA réglementaires et factures accessibles et téléchargeables à tout moment.</p>
            </div>
            <div class="feature-card">
              <i class="fa-solid fa-clock-rotate-left text-orange-500 text-3xl mb-6"></i>
              <h3 class="text-xl font-bold mb-4">Historique complet</h3>
              <p class="text-gray-600">Vos clients consultent le passé et l'avenir de leurs installations : interventions réalisées et rendez-vous planifiés.</p>
            </div>
            <div class="feature-card">
              <i class="fa-solid fa-shield-halved text-orange-500 text-3xl mb-6"></i>
              <h3 class="text-xl font-bold mb-4">Espace 100% sécurisé</h3>
              <p class="text-gray-600">Chaque client dispose d'un accès individuel protégé, garantissant la confidentialité totale des données.</p>
            </div>
          </div>
        </div>
      </section>

      <section class="py-24 bg-gray-50 border-y border-gray-100">
        <div class="max-w-7xl mx-auto px-4">
          <div class="flex flex-col lg:flex-row items-center gap-20">
            <div class="lg:w-1/2">
              <h2 class="text-3xl font-bold text-gray-900 mb-6">Valorisez votre expertise</h2>
              <p class="text-gray-600 mb-8 text-lg">Le portail client n'est pas qu'un outil technique, c'est votre vitrine. Il positionne votre entreprise comme un acteur moderne, organisé et tourné vers la satisfaction client.</p>
              <div class="brand-benefit">
                <div class="b-icon"><i class="fa-solid fa-star"></i></div>
                <div>
                  <h4 class="font-bold">Image Professionnelle</h4>
                  <p class="text-sm text-gray-500">Une interface à la hauteur des grands acteurs du secteur.</p>
                </div>
              </div>
              <div class="brand-benefit">
                <div class="b-icon"><i class="fa-solid fa-headset"></i></div>
                <div>
                  <h4 class="font-bold">SAV allégé</h4>
                  <p class="text-sm text-gray-500">Moins de demandes répétitives pour des duplicatas de documents.</p>
                </div>
              </div>
            </div>
            <div class="lg:w-1/2">
               <div class="app-integration-box">
                  <div class="tag-sync">Synchronisation Native</div>
                  <p class="text-center font-bold text-gray-700">Toutes les informations saisies par vos techniciens sur le terrain sont instantanément visibles par le client.</p>
               </div>
            </div>
          </div>
        </div>
      </section>

      <section class="py-24 bg-white">
        <div class="max-w-7xl mx-auto px-4">
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
            <div v-for="benefit in benefits" :key="benefit" class="benefit-pill">
              <i class="fa-solid fa-circle-check"></i> {{ benefit }}
            </div>
          </div>
        </div>
      </section>

      <section class="py-20 text-center rounded-[4rem] mx-4 mb-10">
        <div class="max-w-3xl mx-auto px-4">
          <h2 class="text-4xl font-black mb-8">Modernisez votre relation client</h2>
          <div class="flex flex-col sm:flex-row justify-center gap-4">
             <a href="/contact"><button class="btn-primary-large">Demander une démonstration</button></a>
             <a href="/fonctionnalites" class="btn-outline-large">Autres fonctionnalités</a>
          </div>
        </div>
      </section>

      <landing-roi />
      <landing-avis />
    </main>

    <landing-footer />
  </div>
</template>

<script>
import LandingHeader from './LandingHeader.vue'
import LandingFooter from './LandingFooter.vue'
import LandingAvis from './LandingAvis.vue'
import LandingROI from './LandingROI.vue'

export default {
  name: 'PortailClientPage',
  components: {
    LandingHeader,
    LandingFooter,
    LandingAvis,
    'landing-roi': LandingROI
  },
  data() {
    return {
      benefits: [
        'Zéro sollicitation inutile',
        'Gain de temps équipes',
        'Satisfaction client boostée',
        'Image de marque forte',
        'Relation durable'
      ]
    }
  }
}
</script>

<style scoped>
/* --- UTILS --- */
.gradient-text {
  background: linear-gradient(to right, #f97316, #ef4444);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* --- HERO --- */
.hero-portail {
  padding: 10rem 0 6rem;
  background: radial-gradient(circle at top right, #fdf4ff, transparent 40%);
}

.badge-portail {
  display: inline-block;
  padding: 0.5rem 1rem;
  background-color: #fae8ff;
  color: #a21caf;
  font-weight: 800;
  font-size: 0.75rem;
  border-radius: 9999px;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
}

/* --- BROWSER MOCKUP --- */
.browser-mockup {
  background: white;
  border-radius: 1rem;
  overflow: hidden;
  border: 1px solid #e5e7eb;
}
.browser-bar {
  background: #f3f4f6;
  padding: 0.75rem 1rem;
  display: flex;
  align-items: center;
  gap: 1.5rem;
}
.dots { display: flex; gap: 0.4rem; }
.dots span { width: 8px; height: 8px; border-radius: 50%; background: #d1d5db; }
.url { background: white; padding: 0.2rem 1rem; border-radius: 0.4rem; font-size: 0.7rem; color: #9ca3af; flex: 1; text-align: center; }

.browser-content { display: flex; height: 300px; }
.sidebar-mock { width: 60px; background: #1f2937; }
.main-mock { flex: 1; padding: 1.5rem; background: #f9fafb; }
.mock-card-wide { background: white; padding: 1rem; border-radius: 0.5rem; margin-bottom: 1rem; box-shadow: 0 2px 4px rgba(0,0,0,0.05); }
.btn-mock { font-size: 0.6rem; background: #f97316; color: white; padding: 0.3rem 0.6rem; border-radius: 0.3rem; font-weight: 700; }
.mock-card-small { background: white; padding: 1.5rem 1rem; border-radius: 0.5rem; text-align: center; font-size: 0.7rem; font-weight: 800; color: #6b7280; box-shadow: 0 2px 4px rgba(0,0,0,0.05); }

/* --- FEATURES --- */
.feature-card { padding: 1rem; }
.brand-benefit { display: flex; gap: 1.5rem; margin-bottom: 2rem; }
.b-icon { width: 3rem; height: 3rem; background: #fff7ed; color: #f97316; border-radius: 0.75rem; display: flex; align-items: center; justify-content: center; font-size: 1.2rem; flex-shrink: 0; }

.app-integration-box {
  background: white;
  padding: 3rem;
  border-radius: 2rem;
  border: 2px dashed #e5e7eb;
  position: relative;
}
.tag-sync {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background: #16a34a;
  color: white;
  padding: 0.3rem 1rem;
  border-radius: 9999px;
  font-size: 0.7rem;
  font-weight: 800;
  white-space: nowrap;
}

/* --- PILLS --- */
.benefit-pill {
  background: #f9fafb;
  padding: 1rem;
  border-radius: 9999px;
  text-align: center;
  font-weight: 800;
  font-size: 0.9rem;
  color: #1f2937;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
}
.benefit-pill i { color: #16a34a; }

/* --- BUTTONS --- */
.btn-primary { background: linear-gradient(to right, #f97316, #ef4444); color: white; padding: 1rem 2.5rem; border-radius: 9999px; font-weight: 700; border: none; }
.btn-primary-large { background: #f97316; color: white; padding: 1.2rem 3rem; border-radius: 9999px; font-weight: 800; border: none; font-size: 1.1rem; }
.btn-outline-large { border: 2px solid #e5e7eb; padding: 1.2rem 3rem; border-radius: 9999px; font-weight: 800; color: #1f2937; text-decoration: none; display: inline-block; }
.btn-outline-large-white { border: 2px solid rgba(255,255,255,0.2); padding: 1.2rem 3rem; border-radius: 9999px; font-weight: 800; color: white; text-decoration: none; display: inline-block; }

@media (max-width: 1024px) {
  .hero-portail { text-align: center; padding-top: 8rem; }
  .hero-portail .flex { flex-direction: column; }
  .browser-mockup { margin-top: 4rem; }
}
</style>